// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "apple-pay-button[data-v-380c3f5d]{--apple-pay-button-width:240px;--apple-pay-button-height:40px;--apple-pay-button-border-radius:3px;--apple-pay-button-padding:0px 0px;--apple-pay-button-box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
